module.exports = __webpack_public_path__ + "static/media/GeraldtonGuardian-devicecomp-min@2x.c46c4148.png";